if (!customElements.get('bt-editorial-carousel')) {
  class BtEditorialCarousel extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-bt-slide]')];
      this.dots = [...this.querySelectorAll('[data-bt-dot]')];
      this.index = Math.max(0, this.slides.findIndex((slide) => slide.getAttribute('aria-hidden') === 'false'));
      this.delay = Number(this.dataset.autoplay || 5000);
      this.autoplay = this.dataset.autoplayEnabled === 'true' && !matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.paused = false;
      this.querySelector('[data-bt-prev]')?.addEventListener('click', () => this.go(this.index - 1, true));
      this.querySelector('[data-bt-next]')?.addEventListener('click', () => this.go(this.index + 1, true));
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.go(index, true)));
      this.addEventListener('mouseenter', () => this.pause());
      this.addEventListener('mouseleave', () => this.resume());
      this.addEventListener('focusin', () => this.pause());
      this.addEventListener('focusout', () => this.resume());
      this.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') this.go(this.index - 1, true);
        if (event.key === 'ArrowRight') this.go(this.index + 1, true);
      });
      this.addEventListener('pointerdown', (event) => { this.pointerX = event.clientX; this.pause(); });
      this.addEventListener('pointerup', (event) => {
        const distance = event.clientX - (this.pointerX || event.clientX);
        if (Math.abs(distance) > 45) this.go(this.index + (distance < 0 ? 1 : -1), true);
        this.resume();
      });
      this.querySelectorAll('[data-bt-slide-link],[data-bt-slide-cta]').forEach((link) => link.addEventListener('click', () => this.track('bt_hero_slide_click')));
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => entry.isIntersecting ? this.resume() : this.pause());
      }, { threshold: .45 });
      this.observer.observe(this);
      this.load(this.index);
      setTimeout(() => this.load(this.index + 1), 1000);
      this.track('bt_hero_slide_view');
      this.resume();
    }

    disconnectedCallback() { clearTimeout(this.timer); this.observer?.disconnect(); }
    pause() { this.paused = true; clearTimeout(this.timer); }
    resume() { this.paused = false; clearTimeout(this.timer); if (this.autoplay && this.slides.length > 1) this.timer = setTimeout(() => this.go(this.index + 1), this.delay); }
    load(index) {
      const slide = this.slides[(index + this.slides.length) % this.slides.length];
      if (!slide) return;
      slide.querySelectorAll('[data-srcset]').forEach((source) => { source.srcset = source.dataset.srcset; source.removeAttribute('data-srcset'); });
      const image = slide.querySelector('img[data-src]');
      if (image) { image.src = image.dataset.src; image.removeAttribute('data-src'); }
    }
    go(next, userInitiated = false) {
      if (!this.slides.length) return;
      this.index = (next + this.slides.length) % this.slides.length;
      this.load(this.index);
      this.load(this.index + 1);
      this.slides.forEach((slide, index) => slide.setAttribute('aria-hidden', index === this.index ? 'false' : 'true'));
      this.dots.forEach((dot, index) => dot.setAttribute('aria-current', index === this.index ? 'true' : 'false'));
      this.track('bt_hero_slide_view');
      if (userInitiated) this.paused = false;
      this.resume();
    }
    track(event) {
      const slide = this.slides[this.index];
      if (!slide) return;
      const payload = { event, slide_id: slide.dataset.slideId, slide_position: this.index + 1, slide_label: slide.dataset.slideLabel };
      if (Array.isArray(window.dataLayer)) window.dataLayer.push(payload);
      this.dispatchEvent(new CustomEvent(event, { bubbles: true, detail: payload }));
    }
  }
  customElements.define('bt-editorial-carousel', BtEditorialCarousel);
}
